import  api, { globalErrorHandler } from "../Api"

export const GET_HOME_VIDEO = "GET_HOME_VIDEO";
export const GET_RAFT_VIDEO = "GET_RAFT_VIDEO";
export const UPDATE_HOME_VIDEO = "UPDATE_HOME_VIDEO";
export const UPDATE_RAFT_VIDEO = "UPDATE_RAFT_VIDEO";
export const VI_LOADING = "VI_LOADING";
export const VI_ERROR = "VI_ERROR";

const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetHomeVideo = () => {
  
  return async dispatch => {
    dispatch({
      type: VI_LOADING
    });
    await api.get(`/CTAs/GetHomeVideo`,config).then(res => {
      dispatch({
        type: GET_HOME_VIDEO,
        data: res.data
        })
        // console.log(res.data)
    }).catch(globalErrorHandler); 
  };
};

export const GetRaftVideo = () => {
  
  return async dispatch => {
    dispatch({
      type: VI_LOADING
    });
    await api.get(`/CTAs/GetRAFTVideo`,config).then(res => {
      dispatch({
        type: GET_RAFT_VIDEO,
        data: res.data
        })
        // console.log(res.data)
    }).catch(globalErrorHandler); 
  };
};

export const UpdateVideo = (payload) => {
  //console.log("addver", payload, files)
  return async dispatch => {
      dispatch({
          type: VI_LOADING
      });

      api.put(`/CTAs/UpdateHomeVideo`, 
      payload, config).then(res => {
          dispatch({
              type: UPDATE_HOME_VIDEO,
              payload: res.data
          });
          //console.log(res.data)
          // history.push(`/Benefits/FormAdminBenefits/${res.data}`);
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: VI_ERROR 
        })
      });
  };
};

export const UpdateRaftVideo = (payload, files) => {
  var formData = new FormData();
  formData.append('id', payload.id);
  formData.append('type', payload.type);
  formData.append('sourceURL', payload.sourceURL);
  formData.append('imageURL', payload.imageURL);
  formData.append('files', files);

  console.log("addver", payload, files)
  const multiConfig = {
      headers: {
          'content-type': 'multipart/form-data',
      }
  }
  return async dispatch => {
      dispatch({
          type: VI_LOADING
      });

      api.put(`/CTAs/UpdateCTA`, 
      formData, multiConfig).then(res => {
          dispatch({
              type: UPDATE_RAFT_VIDEO,
              payload: res.data
          });
          //console.log(res.data)
          // history.push(`/Benefits/FormAdminBenefits/${res.data}`);
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: VI_ERROR 
        })
      });
  };
};
